import CardLogin from 'app/components/Layouts/CardLogin';
import {
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioProps,
  styled,
  Typography,
} from '@mui/material';
import {
  infoText,
  btnBox,
  companyBox,
  voenText,
  companyName,
  radioGroup,
  formGroup,
  signType,
} from './SelectCompany.sx';
import React from 'react';
import useSelectCompany from './useSelectCompany';
import { blue, grey6, white } from 'app/components/ThemeProvider/colors';
import { CompanyType } from 'app/utils/services/types/company.type';
import KeyIcon from 'app/components/Icons/KeyIcon';
import BackButton from 'app/components/BackButton';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  backgroundColor: white,
  border: `2px solid ${grey6}`,
  padding: '0 !important',

  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: blue,
  border: 'none',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: blue,
  },
});

// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
  return <Radio disableRipple color="default" checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />;
}

const SelectCompany = () => {
  const { t, currentIndex, data, selectCompany, isLoadingSelectCompany, handleOnSubmit } = useSelectCompany();

  return (
    <CardLogin>
      <form style={formGroup} onSubmit={handleOnSubmit}>
        <Box>
          <Typography sx={infoText}>{t('selectCompany.select')}</Typography>
          <Box>
            <RadioGroup sx={radioGroup}>
              {data?.companies?.map((item: CompanyType, index: number) => (
                <FormControlLabel
                  key={index}
                  control={<BpRadio />}
                  label={
                    <Box>
                      <Typography sx={voenText}>
                        {t('selectCompany.inn')}: {item.inn}
                      </Typography>
                      <Typography sx={companyName}>{item.title}</Typography>
                      <Typography sx={signType}>
                        <KeyIcon sx={{ mr: '10px' }} />
                        {item.sign_type === 'first'
                          ? t('selectCompany.firstSign')
                          : item.sign_type === 'second'
                          ? t('selectCompany.secondSign')
                          : 'İmza hüququ yoxdur'}
                      </Typography>
                    </Box>
                  }
                  disabled={item.company_status === 'new'}
                  value={item.id}
                  onChange={() => selectCompany(index, item.inn)}
                  sx={currentIndex === index ? { ...companyBox, borderColor: `${blue}` } : companyBox}
                />
              ))}
            </RadioGroup>
          </Box>
        </Box>
        <Box sx={btnBox}>
          <Button
            type={'submit'}
            disabled={currentIndex === undefined || isLoadingSelectCompany}
            variant={'contained'}
            sx={{ mb: '12px' }}
          >
            {isLoadingSelectCompany ? (
              <CircularProgress sx={{ width: '24px !important', height: '24px !important' }} />
            ) : (
              t('login.continue')
            )}
          </Button>
          <BackButton text={'selectCompany.back'} tab={data?.tab} />
        </Box>
      </form>
    </CardLogin>
  );
};

export default SelectCompany;
